import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CanActivateAuthGuard } from '@auth/guards';
import { DprDetailsModule } from '@dpr-details/dpr-details.module';
import { DprModule } from '@dpr/dpr.module';
import { ReportModule } from '@report/report.module';
import {
  ErrorComponent,
  PageNotFoundComponent,
  StyleGuideComponent,
} from '@shared/components';
import { MainLayoutComponent } from '@shared/containers';
import {
  canMatchDprsGuard,
  canActivateStateChangeGuard,
  canActivateDprsGuard,
  canMatchProjectSetupGuard,
  canActivateProjectSetupGuard,
  canMatchSystemAdminGuard,
  canActivateSystemAdminGuard,
  canMatchAdminGuard,
  canActivateAdminGuard,
  canMatchUserAdminGuard,
  canActivateUserAdminGuard,
} from '@shared/guards';

const routes: Routes = [
  {
    path: ':clientId/report/:subprojectId',
    loadChildren: () => ReportModule,
    canMatch: [canMatchDprsGuard],
    canActivate: [
      CanActivateAuthGuard,
      canActivateStateChangeGuard,
      canActivateDprsGuard,
    ],
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [CanActivateAuthGuard],
    canActivateChild: [canActivateStateChangeGuard],
    children: [
      {
        path: ':clientId/dprs/:subprojectId',
        loadChildren: () => DprModule,
        canMatch: [canMatchDprsGuard],
        canActivate: [canActivateDprsGuard],
      },
      {
        path: ':clientId/dpr-details/:subprojectId',
        loadChildren: () => DprDetailsModule,
        canLoad: [canMatchDprsGuard],
        canActivate: [canActivateDprsGuard],
      },
      {
        path: ':clientId/project-setup/:subprojectId',
        loadChildren: () =>
          import('@project-setup/project-setup.module').then(
            (m) => m.ProjectSetupModule
          ),
        canMatch: [canMatchProjectSetupGuard],
        canActivate: [canActivateProjectSetupGuard],
      },
      {
        path: ':clientId/clients',
        loadChildren: () =>
          import('@clients/clients.module').then((m) => m.ClientsModule),
        canMatch: [canMatchSystemAdminGuard],
        canActivate: [canActivateSystemAdminGuard],
      },
      {
        path: ':clientId/project-admin',
        loadChildren: () =>
          import('@project-admin/project-admin.module').then(
            (m) => m.ProjectAdminModule
          ),
        canMatch: [canMatchAdminGuard],
        canActivate: [canActivateAdminGuard],
      },
      {
        path: ':clientId/user-admin',
        loadChildren: () =>
          import('@user-admin/user-admin.module').then(
            (m) => m.UserAdminModule
          ),
        canMatch: [canMatchUserAdminGuard],
        canActivate: [canActivateUserAdminGuard],
      },
      {
        path: 'error',
        component: ErrorComponent,
        pathMatch: 'full',
        data: {
          title: 'Error',
        },
      },
      {
        path: 'style-guide',
        component: StyleGuideComponent,
        pathMatch: 'full',
      },
      {
        path: '',
        redirectTo: 'null/dprs/null',
        pathMatch: 'full',
      },
      { path: '**', component: PageNotFoundComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
